export default __webpack_public_path__ + "static/media/portrait-background.c0314518.jpg";